import Vue from 'vue'
import Vuex from 'vuex'
import myStore from './modules/myStore'
import ticketStore from './modules/ticketStore'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        myStore,
        ticketStore,
    }
})